export class Fornitore {
    Id_fornitore:number;
    NomeFornitore:string;
    lstComodity:Array<number>;
    LinkLogo:string;
    Titolo:string;
    Descrizione:string;
    lstCapGas:Array<string>;

    constructor(){
         
    };
}





// WEBPACK FOOTER //
// ./src/app/model/fornitore.ts